import { JackpotsListDetails } from './JackpotsListDetails';
import { JackpotForGameType } from './JackpotsDetailsModels';
import { Amount } from 'src_common/common/amount/Amount';
import { Common } from 'src/domains/common/Common';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';
import { JackpotsListModel } from 'src/domains/casino/state/AppCasino/casino-sockets/jackpot-socket/JackpotsListModel';

export class JackpotsSocket {
    private readonly data: JackpotsListDetails | null = null;

    public static get = AutoWeakMap.create((common: Common) => new JackpotsSocket(common));
    private constructor(private readonly common: Common) {
        const websocket_casino_jackpots_host = this.common.envVariables.casinoJackpotsUrl;
        if (websocket_casino_jackpots_host === null) {
            console.warn('Casino jackpots host is not defined.');
            return;
        }

        const basicData = BasicDataModel.get(common);
        this.data = new JackpotsListDetails(
            websocket_casino_jackpots_host,
            this.common.isBrowser,
            () => basicData.currency
        );
    }

    public getModel(gameId: number): JackpotForGameType | null {
        const basicDataModel = BasicDataModel.get(this.common);
        if (this.data === null) {
            return null;
        }
        const jackpotsListModel = this.data.getModel();

        if (jackpotsListModel === null) {
            return null;
        }

        const list = jackpotsListModel.jackpotsList.jackpots;

        for (const jackpot of list) {
            if (jackpot.games.filter((jackpotGameId) => jackpotGameId === gameId).length > 0) {
                const jackpotAmount = new Amount(jackpot.amount);
                const jackpotAmountToShow = basicDataModel.money(jackpotAmount, false);

                return {
                    id: jackpot.id,
                    name: jackpot.name,
                    amount: jackpotAmountToShow,
                };
            }
        }
        return null;
    }

    public getAllJackpots(): JackpotsListModel | null {
        if (this.data === null) {
            return null;
        }
        return this.data.getModel();
    }
}
